import type {
    NavLink,
    StatCard,
    FeatureHighlight,
    ServiceItem,
    ProjectItem,
    TeamMember,
    FooterLink,
    CompanyInfo,
    ProcessStep,
    Testimonial,
    FaqItem,
    PricingPlan,
    ClientLogo,
} from './types'

export const navLinks: NavLink[] = [
    { href: '#hakkimizda', label: 'Hakkımızda', iconName: 'Info' },
    { href: '#hizmetler', label: 'Hizmetler', iconName: 'Layers' },
    { href: '#projeler', label: 'Projeler', iconName: 'FolderGit2' },
    { href: '#fiyatlandirma', label: 'Fiyatlar', iconName: 'Tag' },
    { href: '#iletisim', label: 'İletişim', iconName: 'Mail' },
]

export const aboutHighlights: FeatureHighlight[] = [
    { iconName: 'Code2', text: 'Modern ve Temiz Kod Mimarisi' },
    { iconName: 'Layers', text: 'Ölçeklenebilir Çözümler' },
    { iconName: 'Zap', text: 'Yüksek Performans Odaklı' },
]

export const statCards: StatCard[] = [
    { value: '6+', label: 'Yıl Deneyim' },
    { value: '50+', label: 'Tamamlanan Proje' },
    { value: '%98', label: 'Müşteri Memnuniyeti' },
    { value: '3 Hafta', label: 'Ort. Teslimat Süresi' },
]

export const serviceItems: ServiceItem[] = [
    {
        iconName: 'Globe',
        title: 'Modern Web Geliştirme',
        description:
            'Next.js, React ve en güncel web teknolojileriyle yüksek performanslı, SEO dostu ve kullanıcı odaklı web uygulamaları geliştiriyoruz.',
        tech: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS'],
    },
    {
        iconName: 'Smartphone',
        title: 'Mobil Uygulama',
        description:
            'React Native ile iOS ve Android için native performansla çalışan, kullanıcı dostu mobil uygulamalar tasarlıyor ve geliştiriyoruz.',
        tech: ['React Native', 'Expo', 'iOS', 'Android'],
    },
    {
        iconName: 'Settings',
        title: 'Özel Sistem Çözümleri',
        description:
            'İşletmenize özel ERP, CRM, otomasyon sistemleri ve API entegrasyonları ile iş süreçlerinizi dijitalleştiriyoruz.',
        tech: ['Node.js', 'PostgreSQL', 'Redis', 'Docker'],
    },
]

export const projects: ProjectItem[] = [
    {
        id: 1,
        title: 'FiveM Yönetici Paneli',
        category: 'Web Uygulaması',
        description: 'Kurumsal FiveM sunucuları için kapsamlı yönetim paneli',
        image: '/projects/fiveline.webp',
        tech: ['Next.js', 'TypeScript', 'Redis', 'MySQL'],
        color: 'from-blue-500/20 to-purple-500/20',
        isReleased: true,
        link: 'https://fivem.fiveline.com.tr/'
    },
    {
        id: 2,
        title: 'FivePos CRM & ERP',
        image: '/projects/fivepos.webp',
        category: 'Masaüstü Uygulama',
        description: 'Yüksek trafikli muhasebe ve CRM sistemi',
        tech: ['React', 'Electron', 'PostgreSQL'],
        color: 'from-green-500/20 to-teal-500/20',
        isReleased: false,
    },
    {
        id: 3,
        title: 'Bleem Super App',
        category: 'Mobil Uygulama',
        description: 'KKTC yerelinde hizmet veren süper uygulama',
        image: '/projects/bleem.webp',
        tech: ['React Native', 'Expo', 'GraphQL'],
        color: 'from-pink-500/20 to-rose-500/20',
        isReleased: true,
        link: 'https://bleemapp.com/'
    },
    {
        id: 4,
        title: 'UBrewP Café & Garden QR Menü',
        category: 'İşletme Web Sayfası',
        image: '/projects/ubrewp.webp',
        description: 'Restaurantlar için QR kodlu dijital menü sistemi',
        tech: ['Next.js', 'FireBase'],
        color: 'from-orange-500/20 to-amber-500/20',
        isReleased: true,
        link: 'https://qr.ubrewpcafe.com.tr/'
    },
    {
        id: 5,
        title: 'MTN Oto Kurtarma',
        image: '/projects/mtn.webp',
        category: 'İşletme Web Sayfası',
        description: 'Konya MTN Oto Kurtarma için kurumsal web sitesi',
        tech: ['React'],
        color: 'from-violet-500/20 to-indigo-500/20',
        isReleased: true,
        link: 'https://www.mtnotokurtarma.com.tr/'
    },
    {
        id: 6,
        title: 'IoT Kontrol Paneli',
        category: 'Özel Çözüm',
        image: '/projects/zentra.webp',
        description: 'Endüstriyel IoT cihaz izleme ve kontrol sistemi',
        tech: ['Next.js', 'MQTT', 'InfluxDB', 'Grafana'],
        color: 'from-cyan-500/20 to-blue-500/20',
        isReleased: false,
    },
]

export const teamMembers: TeamMember[] = [
    {
        name: 'Arda Altun',
        role: 'Kurucu & Full-Stack Geliştirici',
        bio: 'Modern web altyapıları, gerçek zamanlı sistemler ve ölçeklenebilir yazılım çözümleri üzerine çalışan full-stack geliştirici.',
        image: '/team/ardaaltun.webp',
        social: {
            linkedin: 'https://www.linkedin.com/in/ardaltun/',
            website: "https://www.ardaaltun.com.tr/",
            twitter: 'https://x.com/ardaltuun0',
            github: 'https://github.com/JustL0',
        },
    },
    {
        name: 'Batuhan Sarısoy',
        role: 'Kurucu & Full-Stack Geliştirici',
        bio: 'Modern web ve mobil arayüzler, kullanıcı odaklı tasarımlar ve uçtan uca ürün geliştirme üzerine çalışan full-stack geliştirici.',
        image: '/team/person2.jpg',
        social: {
            linkedin: 'https://www.linkedin.com/in/whoischat/',
            website: 'https://batuhansarisoy.com.tr/',
            github: 'https://github.com/whoisch4t',
            instagram: 'https://www.instagram.com/batuhan.wav/',
        },
    },
    {
        name: 'Furkan Ünal',
        role: 'Operasyon Yöneticisi',
        bio: 'Proje süreçleri, müşteri iletişimi ve operasyon yönetiminde aktif rol alan organizasyon ve analiz uzmanı.',
        image: '/team/furkanunal.webp',
        social: {},
    },
]

export const budgetOptions = [
    { value: '', label: 'Bütçe Aralığı Seçin' },
    { value: '500-2.5k', label: '$500 - $2.500' },
    { value: '2.5k-5k', label: '$2.500 - $5.000' },
    { value: '5k-10k', label: '$5.000 - $10.000' },
    { value: '10k-25k', label: '$10.000 - $25.000' },
    { value: '250k+', label: '$25.000+' },
]

export const companyInfo: CompanyInfo = {
    email: 'info@fiveline.com.tr',
    location: 'Levent, İstanbul, Türkiye',
    description: 'Vizyonunuzu koda döküyoruz. Modern yazılım çözümleriyle işinizi geleceğe taşıyoruz.',
    social: [
        { href: 'https://github.com/FiveLine-Development', label: 'GitHub', iconName: 'Github' },
        { href: 'https://www.linkedin.com/company/fiveline-com-tr', label: 'LinkedIn', iconName: 'Linkedin' },
        { href: 'https://www.instagram.com/fiveline.com.tr/', label: 'Instagram', iconName: 'Instagram' },
        { href: 'https://discord.gg/byDGsmZ9mh', label: 'Discord', iconName: 'Discord' },
    ],
}

export const footerLinks: FooterLink[] = [
    { href: '/nedir', label: 'Hakkımızda (Nedir?)' },
    { href: '/#hizmetler', label: 'Hizmetler' },
    { href: '/#projeler', label: 'Projeler' },
    { href: '/#fiyatlandirma', label: 'Fiyatlandırma' },
    { href: '/sss', label: 'SSS (Bilgi Bankası)' },
    { href: '/#iletisim', label: 'İletişim' },
]

export const footerServices: string[] = [
    'Web Geliştirme',
    'Mobil Uygulama',
    'UI/UX Tasarım',
    'API Geliştirme',
    'Danışmanlık',
]

export const processSteps: ProcessStep[] = [
    {
        number: 1,
        iconName: 'Search',
        title: 'Keşif & Analiz',
        description: 'Projenizi, hedeflerinizi ve rekabet ortamınızı derinlemesine analiz ediyoruz. İhtiyaç analizi ile doğru çözümü birlikte belirliyoruz.',
    },
    {
        number: 2,
        iconName: 'Figma',
        title: 'Tasarım & Prototip',
        description: 'UI/UX tasarımı ve interaktif prototip oluşturuyoruz. Geri bildirimlerinizle geliştirip onayınızı alıyoruz.',
    },
    {
        number: 3,
        iconName: 'Code2',
        title: 'Geliştirme & Test',
        description: 'Modern teknolojilerle, temiz ve ölçeklenebilir kod yazıyoruz. Her aşamada kapsamlı test süreçleri uyguluyoruz.',
    },
    {
        number: 4,
        iconName: 'Rocket',
        title: 'Teslimat & Destek',
        description: 'Projeyi canlıya alıyor, eğitim veriyoruz. Lansman sonrası teknik destek ve bakım hizmeti sunuyoruz.',
    },
]

export const testimonials: Testimonial[] = [
    {
        name: 'Can G.',
        role: 'Kurucu',
        company: 'Snakepit Visuals',
        image: '/clients/cano5.webp',
        quote: 'Shop sunucumuzun düzenleme ve kurulum sürecinden çok memnun kaldık. Taleplerimize hızlı ve profesyonel dönüş sağladılar; teknik destekleri sayesinde Discord altyapımız daha stabil ve modern hale geldi. FiveM ve Discord projeleri için FiveLine Development ekibini gönül rahatlığıyla tavsiye ederiz.',
        rating: 5,
    },
    {
        name: 'Ege Çetinkaya',
        role: 'CEO & Founder',
        company: 'Bleem Super App',
        image: '/clients/bleem.webp',
        quote: 'FiveLine Development ekibiyle çalışmak, Bleem projesi için verdiğimiz en doğru kararlardan biri oldu. Teknik bilgi, hızlı destek ve çözüm odaklı yaklaşımları sayesinde projemiz çok daha güçlü bir altyapıya kavuştu. Güvenilir bir yazılım ekibi arayan herkese kesinlikle tavsiye ederim.',
        rating: 5,
    },
    {
        name: 'Özgür Sefa Çelikörs',
        role: 'İşletme Sahibi',
        company: 'UBrewP Café & Garden',
        image: '/clients/ozgursefa.webp',
        quote: 'FiveLine Development sayesinde UBrewP için modern, hızlı ve kullanıcı dostu bir QR menü sistemine sahip olduk. Hem müşterilerimizden aldığımız geri dönüşler hem de operasyonel tarafta sağladığı kolaylık beklentimizin çok üstünde oldu. Süreç boyunca sundukları destek ve profesyonel yaklaşımları için teşekkür ederiz.',
        rating: 5,
    },
]

export const faqItems: FaqItem[] = [
    {
        question: 'Bir proje ne kadar sürede teslim edilir?',
        answer: 'Projenin kapsamına göre değişmekle birlikte; kurumsal web siteleri 3-6 hafta, mobil uygulamalar 6-14 hafta, özel sistem çözümleri ise 8-20 hafta arasında teslim edilmektedir. Kesin süreyi keşif toplantısının ardından paylaşıyoruz.',
    },
    {
        question: 'Proje sürecinde nasıl iletişim kuruyoruz?',
        answer: 'Her proje için Slack üzerinden özel bir kanal açıyoruz. Haftada iki kez ilerleme toplantısı yapıyoruz. Ayrıca proje yönetim paneli üzerinden tüm süreç şeffaf şekilde takip edilebilir.',
    },
    {
        question: 'Hangi teknolojileri kullanıyorsunuz?',
        answer: 'Frontend\'de Next.js, React ve Tailwind CSS; backend\'de Node.js ve PostgreSQL tercih ediyoruz. Mobil için React Native kullanıyoruz. Projeye özel gereksinimler için ek teknolojiler de devreye alınabilir.',
    },
    {
        question: 'Proje tesliminden sonra destek veriyor musunuz?',
        answer: 'Evet, tüm projelerimizde ilk 3 ay ücretsiz teknik destek sunuyoruz. Sonrasında aylık bakım paketleri ile uzun vadeli destek sağlayabiliyoruz. Acil durumlarda 4 saat içinde müdahale garantisi veriyoruz.',
    },
    {
        question: 'Kaç revizyon hakkım var?',
        answer: 'Tasarım aşamasında sınırsız revizyon hakkı tanıyoruz. Geliştirme aşamasında ise kapsamı aşmayan değişiklikler için ek ücret talep etmiyoruz. Kapsam dışı talepler önceden mutabık kalınan birim fiyatlarla gerçekleştirilir.',
    },
    {
        question: 'Ödeme koşulları nasıl işliyor?',
        answer: 'Projeler genellikle %30 başlangıç, %40 geliştirme ortası ve %30 teslimat şeklinde üç taksitte faturalandırılır. Kurumsal projeler için farklı ödeme planları da düzenlenebilir.',
    },
    {
        question: 'Kaynak kodun sahipliği kime ait olacak?',
        answer: 'Proje tesliminin ardından tüm kaynak kodlar, tasarım dosyaları ve dokümantasyon size devredilir. Siz sahip olursunuz, biz sadece üreticiyiz.',
    },
    {
        question: 'NDA ve gizlilik sözleşmesi imzalıyor musunuz?',
        answer: 'Evet, proje başlamadan önce NDA imzalıyoruz. Proje bilgileriniz, ticari sırlarınız ve verileriniz tamamen gizli tutulur ve üçüncü taraflarla paylaşılmaz.',
    },
]

export const pricingPlans: PricingPlan[] = [
    {
        name: 'QR Menü',
        price: '$400',
        period: 'yıllık',
        description: 'Cafe ve restoranlar için POS entegrasyonlu dijital menü sistemi',
        popular: false,
        cta: 'QR Menü Siparişi Ver',
        features: [
            { text: 'QR kodlu dijital menü sayfası', included: true },
            { text: 'Tüm POS programlarıyla entegrasyon altyapısı', included: true },
            { text: 'Ürün, kategori ve fiyat yönetimi', included: true },
            { text: 'Mobil uyumlu hızlı menü deneyimi', included: true },
            { text: 'Yıllık bakım ve teknik destek', included: true },
            { text: 'Online ödeme entegrasyonu', included: false },
            { text: 'Özel web uygulaması', included: false },
            { text: 'Mobil uygulama', included: false },
        ],
    },
    {
        name: 'Starter',
        price: '$550',
        period: 'proje başlangıcı',
        description: 'KOBİ\'ler ve startuplar için kurumsal web varlığı',
        popular: false,
        cta: 'Web Sitemi Yaptır',
        features: [
            { text: 'Kurumsal web sitesi (5-10 sayfa)', included: true },
            { text: 'Mobil responsive tasarım', included: true },
            { text: 'SEO temel optimizasyon', included: true },
            { text: 'İletişim formu entegrasyonu', included: true },
            { text: '3 ay ücretsiz destek', included: true },
            { text: 'Mobil uygulama', included: false },
            { text: 'Özel backend geliştirme', included: false },
            { text: 'API entegrasyonları', included: false },
        ],
    },
    {
        name: 'Growth',
        price: '$1.650',
        period: 'proje başlangıcı',
        description: 'Büyüyen işletmeler için tam kapsamlı dijital çözüm',
        popular: true,
        cta: 'Hemen Başlayalım',
        features: [
            { text: 'Web uygulama + yönetim paneli', included: true },
            { text: 'Mobil uygulama (iOS & Android)', included: true },
            { text: 'Özel backend & API geliştirme', included: true },
            { text: 'Ödeme sistemi entegrasyonu', included: true },
            { text: '6 ay ücretsiz destek', included: true },
            { text: 'Performans & SEO optimizasyon', included: true },
            { text: 'ERP/CRM entegrasyonu', included: false },
            { text: 'Özel sunucu kurulumu', included: false },
        ],
    },
    {
        name: 'Enterprise',
        price: 'Özel Fiyat',
        period: 'teklif alın',
        description: 'Kurumsal ölçekte özel sistem ve entegrasyon çözümleri',
        popular: false,
        cta: 'Özel Teklif Al',
        features: [
            { text: 'Sınırsız kapsamlı geliştirme', included: true },
            { text: 'ERP / CRM / BI entegrasyonları', included: true },
            { text: 'Microservices mimarisi', included: true },
            { text: 'Özel sunucu & DevOps kurulumu', included: true },
            { text: '12 ay premium destek', included: true },
            { text: 'Dedicated proje ekibi', included: true },
            { text: 'SLA garantisi', included: true },
            { text: '7/24 acil destek hattı', included: true },
        ],
    },
]

export const clientLogos: ClientLogo[] = [
    { name: 'Snakepit Visuals', initials: 'CV', logo: '/clients/cano5.webp' },
    { name: 'UBrewP Café & Garden', initials: 'UP', logo: '/clients/ubrewp.webp' },
    { name: 'MTN Oto Kurtarma', initials: 'MT', logo: '/clients/mtnlogo.webp' },
    { name: 'Bleem App', initials: 'BA', logo: '/clients/bleem.webp' },
    { name: 'Black V Roleplay', initials: 'BV', logo: '/clients/blackv.webp' }
]
